import { BaseApiService } from "../base/base-api.service";
import { EmployeeDocumentDTO } from "../../models/employee-documents";
import { EmployeeDocumentsDTO } from "../../models/employee-documents";
import { EmployeeDocumentsFilter } from "../../models/employee-documents";
import { DocumentSTO } from "../../models/documents";
import { PageByDocType } from "../../models/employee-document-requests/document-request-filter";

// Used only to lo
export class EmployeePermanentDocumentsApiService extends BaseApiService<EmployeeDocumentDTO, DocumentSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeDocuments",
      loadItemsPath: "/GetEmployeePermanentDocuments",
      saveItemsPath: "",
    });
  }
}

export const loadEmployeePersonalDocuments = async (
  employeeId: string,
  forManager: boolean,
  pageNumber: number,
  pageSize: number,
  signal?: AbortSignal
) => {
  const apiService = new EmployeePermanentDocumentsApiService();
  if (!forManager) {
    apiService.useLoadItemsPath("/GetCurrentUserEmployeePermanentDocuments");
  }
  const response = await apiService.loadItems(
    { employeeId } as EmployeeDocumentsFilter,
    undefined,
    undefined,
    {
      pageSize,
      pageNumber,
    },
    undefined,
    60,
    signal
  );

  return response;
};

export class EmployeeChangingDocumentsApiService extends BaseApiService<EmployeeDocumentsDTO, DocumentSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeDocuments",
      loadItemsPath: "/GetCurrentUserEmployeeChangingDocuments",
      saveItemsPath: "",
    });
  }
}

export const loadEmployeeChangingDocuments = async (
  employeeId: string,
  pagingByDocType: PageByDocType[],
  forManager: boolean,
  pageNumber: number,
  pageSize: number,
  pageByDocTypeInitialSize?: number,
  signal?: AbortSignal
) => {
  const apiService = new EmployeeChangingDocumentsApiService();

  if (forManager) {
    apiService.useLoadItemsPath("/GetEmployeeChangingDocuments");
  }
  const response = await apiService.loadItems(
    {
      employeeId,
      pageByDocTypeInitialSize,
      pagingByDocType,
    } as EmployeeDocumentsFilter,
    undefined,
    undefined,
    {
      pageSize,
      pageNumber,
    },
    undefined,
    undefined,
    signal
  );

  return response;
};
